import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { UpdateCsvExcelTradesAdditionsService } from "@/features/accounts/csv-excel/services/update-trades-additions-service";
import { MoneyLinkError, MoneyLinkException, ErrorLevel } from "@/shared/utils/custom-exception";


export const useUpdateCsvExcelTradesAdditions = () => {
  const { setError } = useContext(ErrorDialogContext);
  const loadingCtx = useContext(LoadingModalContext);
  const updateCsvExcelTradesAdditionsService = new UpdateCsvExcelTradesAdditionsService();
  
  // CSV/Excel明細更新
  const updateCsvExcelTradesAdditions = async (
    AccountGroupId: string,
    mlinkAccountId: string,
    tradeId: string,
    memo?: string,
    inValid?: number,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await updateCsvExcelTradesAdditionsService.updateCsvExcelTradesAdditions({
        account_group_id: AccountGroupId,
        csvexcel_account_id: mlinkAccountId,
        trade_id: tradeId,
        ...(memo && {memo: memo}),
        ...(inValid !== undefined && {is_invalid: inValid}),
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("updateCsvExcelTradesAdditions:", error);
      // メモのバリデーションエラー(webmoneylink_parameter_error)時は専用メッセージに差し替える
      if (
        error instanceof MoneyLinkException &&
        error.error.props.reason === "webmoneylink_parameter_error"
      ) {
        throw new MoneyLinkException({
          error: new MoneyLinkError({
            level: ErrorLevel.Warn,
            code: error.error.props.code,
            reason: error.error.props.reason,
            messageTitle: undefined,
            messageBody:
              "メモに使用できない文字が含まれているか、文字数が上限を超えています。\n入力内容をご確認ください。",
          }),
        });
      }
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    updateCsvExcelTradesAdditions: errorHandledAsync(updateCsvExcelTradesAdditions, setError),
  };
};
